// l10n status: done
import { LinearProgress, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import CheckCircle from "@mui/icons-material/CheckCircle"
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked"
import { Img } from "components/Img"
import adultContent from "img/fallback/adult_content.png"
import PinLock from "img/icons/pin_protected.svg"
import {useAdultPinGuard} from "hooks/useAdultPinGuard"
import { CreateComponent } from "components/utils/CreateComponent.js"
import { useNavigateRouteAdd } from "components/utils/RouteUtils"
//import seriesLogo from "img/series-folder.svg"
import seriesLogo from "img/icons/series.svg"
import recording_failed from "img/recording_indicators/recording_failed.svg"
import React from "react"
import { ROUTE_NAMES } from "site-ql/RouteConst"
import { rootStore } from "store/RootStore"
import { emptyPng, fallbackImageCategory } from "store/util/fallbackImage"
import { theme as _theme } from "../../../site-ql/theme"
import { moment } from "store/util/moment"
import { analyticsScreen, analyticsMeta, analyticsProgramDetailsSource } from "store/qlapi/LogService"

import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"

import "./recordingComponentsStyles.css"
import { l10n } from "store/lang/L10n"

// MTVW - 206 these classes override the default material UI classes
const styles = theme => ({
	MoviesProgressBar: { background: alpha(theme.palette.primary[50], 0.24) },
})

export const MovieTile = CreateComponent(styles, false, true, ({ classes, movie, isDelete, isDeleteSelected, deleteMarkCallback, onClickCallback = null, routeProps, isShowEpisodeTitle }) => {
	const imageCategory = fallbackImageCategory(movie.Title?.Genres?.itemFirst?.type, "tv_category_all.png")
	const navigateRouteAdd = useNavigateRouteAdd()
	const nDash = '\u2013'
	const cocoBookmarks = rootStore.page.CoCoBookmarks

	const [bookmarkProgress, setBookmarkProgress] = React.useState(null)
	React.useEffect(() => {
		if (movie.Type === "Event") {
			if (cocoBookmarks.refreshCount) cocoBookmarks.getBookmarkAsync(null, false, movie.EventId).then((bm) => {
				if (bm && !rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id)) {
					// MTVW-899: don't hide anymore
					//const barProgress = bm.hidden ? 0 : 100 * (bm.position - moment(movie?.StartTime).utc().valueOf()) / (moment(movie?.EndTime).utc().valueOf() - moment(movie?.StartTime).utc().valueOf())
					const barProgress = 100 * (bm.position - moment(movie?.StartTime).utc().valueOf()) / (moment(movie?.EndTime).utc().valueOf() - moment(movie?.StartTime).utc().valueOf())
					//console.debug("bookmarkProgress", barProgress)
					// MTVW-946: cap bookmark progress
					setBookmarkProgress(Math.min(barProgress, 100))
					//console.debug("useEffect MovieTile", barProgress, res?.position, movie?.StartTime, movie?.EndTime, movie)
				}
				else setBookmarkProgress(null)
			})
		}

		return () => {
			//rootStore.page.Recordings.Manager.closeRecordingEvent(oEventData)
		}
	}, [cocoBookmarks.refreshCount])

	const { handleProtectedClick, PinGuardElement } = useAdultPinGuard((channel) => {
		handleMovieCardSelection()
	})

	const handleOnClick = () => {
		if (onClickCallback !== null) {
			onClickCallback(movie)
		}
		// serie
		else if (movie.isSeries) {
			navigateRouteAdd(ROUTE_NAMES.RecordingsSeriesList, { ...routeProps, ...{ serieId: movie.id, SeriesId: movie.SeriesId } })
		}
		// single
		else {
			const location = window.location.href
			let source = ""
			if (location) {
				const section = location.substring(location.lastIndexOf("/") + 1)
				//console.debug("section", section)
				switch (section) {
					case "recordings":
						source = analyticsProgramDetailsSource.recordings
						break
					case "newrecs":
						source = analyticsProgramDetailsSource.newRecordings
						break
					case "single":
						source = analyticsProgramDetailsSource.singleRecordings
						break
					case "series":
						source = analyticsProgramDetailsSource.seriesRecordings
						break
					case "planned":
						source = analyticsProgramDetailsSource.scheduledRecordings
						break
					case "archived":
						source = analyticsProgramDetailsSource.archivedRecordings
						break
					default:
						if (location.indexOf("series_details") >= 0) source = analyticsProgramDetailsSource.recordingEpisodes
						break
				}
			}
			// setShow first so that derived 'origin' is correct
			// MTVW-938: Enable check for isReplayAllowed in "planned" section to properly display or hide play buttons
			rootStore.page.OverlayEventDetails.setShow(true, routeProps.type !== "planned" ? CALLING_CONTEXT_TYPE.Recording : CALLING_CONTEXT_TYPE.TvGuide)
			rootStore.page.OverlayEventDetails.setEpgEventById(movie.EventId, false, source.length > 0 ? { [analyticsMeta.screen]: analyticsScreen.programDetails, source: source } : {}).then(res => {
				// MTV-3570: Need movie.id for media microservice instead of movie.Content?.id
				// MTVW-938: DO NOT use the recording id if it's in the "planned" section
				if (routeProps.type !== "planned") rootStore.page.OverlayEventDetails.setTypeContentPlaylist(movie.id)
				rootStore.page.OverlayEventDetails.setComponentType('event')
			})
		}
	}
	const handleMovieCardSelection = () => {
		if (isDelete) {
			deleteMarkCallback()
		} else
			handleOnClick()
	}

	// MTVW-1015
	const seasonInfo = () => {
		const season = movie.Title.SeasonNum ? `S${movie.Title.SeasonNum}` : ""
		const episode = movie.Title?.SeriesCollection?.RelationOrdinal ? `E${movie.Title?.SeriesCollection?.RelationOrdinal}` : ""
		const separator = season !== "" || episode !== "" ? "• " : ""
		let episodeName = movie.Title.EpisodeName ? separator + movie.Title.EpisodeName : movie.Title.EpisodeTitle ? separator + movie.Title.EpisodeTitle : ""
		if (episodeName.indexOf(movie.Name) >= 0 ) episodeName = ""
		let info = `${season} ${episode} ${episodeName}`.trim()
		//console.debug("seasonInfo", info, info.length, item)
		//console.debug("episodeName", movie.Title.EpisodeName, movie.Title.EpisodeTitle)
		if (info === movie.Name) info = ""
		return info
	}

	const hasSeasonInfo = () => {
		return rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) ? false : seasonInfo()?.length > 0
	}
	
	//if (movie.isSeries) console.debug("MovieTile series", movie)

	//console.debug("MovieTile %s, Season %s, Episode %s, EpisodeTitle %s, EpisodeName %s", movie.Name, movie.Title.SeasonNum, movie.Title?.SeriesCollection?.RelationOrdinal, movie.Title.EpisodeTitle, movie.Title.EpisodeName, movie.Title, movie)
	//console.debug("seasonInfo", seasonInfo())

	// MTVW-646: for adult movies Channel will not be set by Traxis because we filter them out in the GetRecordings request
	// -> suppress content with no valid Channel
	//return (
	return !movie?.Channel ? null : (
		<>
		{PinGuardElement}
		<div className="MoviesGrid"
			style={isDelete && isDeleteSelected ? { border: `2px solid ${_theme.palette.primary["main"]}` } : {}}
			data-test={movie.isSeries ? "series" : "episode"}>
			{isDeleteSelected && isDelete && <CheckCircle className="MoviesDeleteIcon" onClick={/*handleMovieCardSelection*/ (e) => handleProtectedClick(movie?.Channel)} />}
			{isDelete && <RadioButtonUnchecked className="MoviesDeleteIcon" onClick={/*handleMovieCardSelection*/ (e) => handleProtectedClick(movie?.Channel)} />}
			{/* MTVW-938: Failed indicator, option 1
			{movie.State === "Failed" &&
				<img src={recording_failed} className="MoviesDeleteIcon" style={{ top: 220 }} alt="Failed" />
			}
			*/}

			<div className="MoviesPosterWrapper" style={{ backgroundImage: `url(${imageCategory})` }} onClick={/*handleMovieCardSelection*/ (e) => handleProtectedClick(movie?.Channel)}>
				{rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) ?
					<Img loading="lazy" src={adultContent} params="mode=box&w=480&h=270" hideBefore={true} fallback={emptyPng} alt={movie.Name} className="MoviesPoster" />
				:
					<Img loading="lazy" src={movie.Title?.Pictures?.getBoxCover} params="mode=box&w=480&h=270" hideBefore={true} fallback={emptyPng} alt={movie.Name} className="MoviesPoster" />
				}
				{/*
				{movie.isSeries ? (
					<img src={seriesLogo} className="MovieTypeLogo" alt="Serie" />
				) : (
					<div className="MoviesProgressBarWrapper">
						<LinearProgress
							variant="determinate"
							value={movie.BookmarkProgress ?? 0}
							className={classes.MoviesProgressBar}
							sx={{
								"& .MuiLinearProgress-bar": {
									backgroundColor: "#F3F3F3"
								}
							}}
						/>
					</div>
				)}
				*/}
			</div>
			{/* MTVW-1015: data-test="episode_recorded" for BDD locator EPISODE_RECORDED */}
			<div className="MoviesGridTextWrapper" data-test={routeProps.type === "single" ? "episode_recorded" : ""} onClick={/*handleMovieCardSelection*/ (e) => handleProtectedClick(movie?.Channel)}>
				{movie.isSeries ? (
					<>
						<img loading="lazy" src={seriesLogo} className="MovieTypeLogo" alt="Serie" />
						<div style={{ height: 15 }}></div>
					</>
				) : (
					// moved from inside MoviesPosterWrapper, place below poster, add style to reset parent padding
					(<div className="MoviesProgressBarWrapper" style={{ top: 0, position: "relative", margin: "-5px -5px 15px -5px", width: "unset" }}>
						{/* bookmarkProgress > 0 */}
						{bookmarkProgress !== null && !rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) ?
							<LinearProgress
								variant="determinate"
								//value={movie.BookmarkProgress ?? 0}
								value={Math.max(0, Math.min(100, Math.round(bookmarkProgress)))}
								className={classes.MoviesProgressBar}
								sx={{
									"& .MuiLinearProgress-bar": {
										backgroundColor: "#F3F3F3"
									}
								}}
							/>
							: <div style={{ height: 4 }}></div>
						}
					</div>)
				)}
				<Typography variant="overline" className="MoviesChannel" noWrap={true}>
					{movie?.Channel?.Name}
				</Typography>
				{/* MTVW-1015:
					<Typography variant="body2" className="MoviesTitle" data-test="movie_title_recording">
				 */}
				{/* height needed for Safari */}
				<div style={{height: rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) ? 81 : 45}}>
					{/* 
						if the episode number and the title of the episode are not present we insert the title of the series as title
						if the episode number is present but not the title of the episode, we insert only the episode number as title of the episode
						if the episode number and the title of the episode are present, we use both as titles
					*/}
					{/* MTVW-820 NOTE: movie.Name may contain "Season", e.g. "Richterin Barbara Salesch Season 13"
						 For consistency it should be "Staffel" instead.
				   */}
					{/*console.debug("EpisodeName", movie.Title.EpisodeName, movie)*/}
					{/* MTVW-1015: replaced with code below
					{isShowEpisodeTitle === true ?
						`${movie.Title.EpisodeNum !== null ?
							//`Episode ${movie.Title.EpisodeNum}  ${movie.Title.EpisodeName === null ? "" : movie.Title.EpisodeName}`
							`${l10n.featureDetailsEpisode} ${movie.Title.EpisodeNum}  ${movie.Title.EpisodeName === null ? "" : movie.Title.EpisodeName}`
							:
							`${movie.Title.EpisodeName === null ? movie.Name : movie.Title.EpisodeName}`
						}`
						:
						movie.Name
					}
					*/}
					{/*console.debug("isShowEpisodeTitle", isShowEpisodeTitle)*/}
					{hasSeasonInfo() ?
						<>
						<div className="MoviesTitleWithEpisode" data-test={isShowEpisodeTitle ? "movie_title_recording" : "movie_episode_title_recording"} style={{visibility: isShowEpisodeTitle ? "visible" : "hidden"}}>{movie.Name}</div>
						<div className="seasonInfo"> {seasonInfo()} </div>
						</>
					:
						<>
						{rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) ?
							<div style={{display: "flex", flexDirection: "row"}}>
							<img style={{ width: 16, height: 16, marginTop: 2, marginRight: 10 }} src={PinLock}></img>
							<div className="MoviesTitle" style={{ position: "relative", top: -6}} data-test="movie_title_recording">
								{l10n.featureContentPinProtected}
							</div>
							</div>
							:
							<div className="MoviesTitle" data-test="movie_title_recording">
								{movie.Name}
							</div>
						}
						</>
					}

					{/* 
					before MTV-2103
					{isShowEpisodeTitle === true && (movie.Title?.EpisodeNum !== null || movie.Title.EpisodeName !== null) ?
						`Episode ${movie.Title.EpisodeNum}
						: 
						${movie.Title.EpisodeName}` : movie.Name}
					*/}
				</div>
				{!rootStore.channelsService?.isChannelPinProtected(movie?.Channel?.id) &&
				<>
				{/* MTVW-1078: marginRight if movie.isSeries to add ellipsis */}
				<Typography style={{marginRight: movie.isSeries ? 36 : 0}} variant="caption" noWrap={true} className="MoviesDetails">
					{/* {movie.IsPersonal ? "Privat" : movie.isCurrentProfile ? "Für alle Profile" : movie.hasProfileNickname && "Aufgenommen von " + (movie.ProfileNickname ?? "")} */}
					{/* MTVW-1015 remove 'Privat'
					{movie.IsPersonal ? `${l10n.featureRecordingsProfilePersonal}` : movie.isCurrentProfile ? `${l10n.featureRecordingsProfileAll}` : movie.hasProfileNickname && `${l10n.featureRecordingsRecordedBy.format(movie.ProfileNickname ?? "")}`}
					*/}
					{movie.IsPersonal ? "" /*`${l10n.featureRecordingsProfilePersonal}`*/ : movie.isCurrentProfile ? `${l10n.featureRecordingsProfileAll}` : movie.hasProfileNickname && `${l10n.featureRecordingsRecordedBy.format(movie.ProfileNickname ?? "")}`}
				</Typography>

				<Typography variant="caption" noWrap={true} data-test="recording_time_info">
					{movie.isSeries
						//? `${movie.childRecordingsCount} ${movie.childRecordingsCount === 1 ? "Episode" : "Episoden"}`
						? movie.childRecordingsCount === 1 ? `${l10n.featureRecordingsNumberSingleEpisode.format(movie.childRecordingsCount)}` : `${l10n.featureRecordingsNumberOfEpisodes.format(movie.childRecordingsCount)}`
						: `${movie?.StartTimeDateFormat("DD.MM.YYYY")}, ${movie?.StartTimeDateFormat("HH:mm")}${nDash}${movie?.EndTimeDateFormat("HH:mm")}`}
				</Typography>
				{/* MTVW-938: Failed indicator, option 2 */}
				{routeProps.type === "planned" && movie.State === "Failed" &&
					<div style={{ display: "flex", position: "relative", top: 4, height: 16 }}>
						<img src={recording_failed} alt="Failed" style={{ marginRight: 6 }} />
						<Typography variant="caption" noWrap={true} className="MoviesDetails" data-test="recording_status">
							{l10n.featureDetailsRecordingStatusFailed}
						</Typography>
					</div>
				}
				</>
			}
			</div>
		</div>
		</>
	)
})


// MTVW-206 code abow is never used?
// export const MovieTileEmpty = CreateComponent(styles, false, false, ({ classes }) => <Grid item className={classes.MoviesGrid} />)
